import { ReactElement } from "react";
import { AppStoreDialog } from "client/Features/Apps/Store/AppStoreDialog";

export type NewMainAppPromotionActivityInvocationProps = {
	onDismiss: () => void;
};

export const NewMainAppPromotionActivityInvocation = (props: NewMainAppPromotionActivityInvocationProps): ReactElement => {
	const {
		onDismiss
	} = props;

	return (
		<AppStoreDialog
			onClose={onDismiss}
		/>
	);
};

NewMainAppPromotionActivityInvocation.displayName = "NewMainAppPromotionActivityInvocation";